export async function concurExpenseConnect(companyId, requestToken, userId, verificationCode) {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/connect?companyId=${companyId}&requestToken=${requestToken}&userId=${userId}&verificationCode=${verificationCode}`);
    const data = await response.json();
    return data;
}